import React from 'react'
import BrandForm from "../../components/Brands/BrandForm/Index"
import BrandList from "../../components/Brands/BrandList/BrandList.component"

function BrandsPage() {
  return (
    <div>
        <BrandForm/> 
        <BrandList/>
    </div>
  )
}

export default BrandsPage